// @ts-nocheck
import { AccordionStyle } from "@insite/mobius/Accordion";
import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import ChevronDown, { ChevronDownOffset } from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles, iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const _headerButtonBaseStyles = () => {
    return css`
        ${focusStyles()}
        background-color: ${getColor("common.background")}; /* Store Custom Code */
        border: 1px solid ${getColor("common.border")}; /* Store Custom Code */
        color: ${getColor("text.main")};
        transition: ${transitionHoverStyles("background-color", "color", "border-color")};

        ${({ theme }) => css`
            ${breakpointValues(theme.design.accordion.padding.vertical, ["padding-top", "padding-bottom"])}
            ${breakpointValues(theme.design.accordion.padding.horizontal, ["padding-right", "padding-left"])}
            font-size: ${theme.design.typography.size.base};
            font-weight: ${theme.design.typography.weight.bold};
            line-height: ${theme.design.typography.lineHeight.small};
        `}

        &[aria-expanded="true"] {
            background-color: ${getColor("common.background")};
            border-color: ${getColor("common.border")};
        }

        &:hover {
            color: ${getColor("primary.main")};
        }

        ${breakpoint("lg")} {
            font-size: ${x => x.theme.design.typography.size.large};
        }
    `;
};

const _headerButtonStyles = () => {
    return css`
        button {
            ${_headerButtonBaseStyles()}

            &:focus,
            &:focus-visible {
                ${_headerButtonBaseStyles()}
            }
        }
    `;
};

const accordion: Styleguide["accordion"] = {
    sectionDefaultProps: {
        headerProps: {
            css: css`
                ${_headerButtonStyles()}

                /* Store Custom Code - Start */
                ${AccordionSectionPanel} + && {
                    > button {
                        border-top: none !important;
                    }

                    ${_headerButtonStyles()}
                }
                /* Store Custom Code - End */
            `,
        },
        panelProps: {
            css: css`
                ${({ theme }) => css`
                    ${breakpointValues(theme.design.accordion.padding.horizontal, "padding")}
                    ${breakpointValues(theme.design.accordion.padding.vertical, "padding-top")}
                `}
                background-color: ${getColor("common.background")};
                border: 1px solid ${getColor("common.border")};
                border-top: none;
            `,
        },
        toggleIconProps: {
            src: ChevronDown,
            color: "primary", // Store Custom Code
            css: css`
                ${iconScalableStyles("1.2em", ChevronDownOffset)}
                margin-left: 1em;
            `,
        },
        titleTypographyProps: null as any,
        toggleTransition: {
            transitionCss: css`
                transition: none;
                bottom: auto;
            `,
            timeout: { enter: 0, exit: 0 },
        },
    },
};

export default accordion;
